const key = (name: string, id: string | number) => `analytics-once:${name}:${id}`
const throttleKey = (name: string, id?: string) =>
  `analytics-throttle:${name}:${id || 'global'}`

export const sample = (rate: number) => Math.random() < rate

export const throttleOncePer = (key: string, ms: number) => {
  try {
    const k = throttleKey('throttle', key)
    const raw = sessionStorage.getItem(k)
    const now = Date.now()
    if (!raw) {
      sessionStorage.setItem(k, String(now))
      return true
    }
    const last = Number(raw)
    if (Number.isFinite(last) && now - last >= ms) {
      sessionStorage.setItem(k, String(now))
      return true
    }
    return false
  } catch {
    return true
  }
}

export function shouldSendOnce(
  name: string,
  id: string | number,
  ttlMs = 1000 * 60 * 10
) {
  try {
    const k = key(name, id)
    const raw = sessionStorage.getItem(k)
    const now = Date.now()
    if (!raw) {
      sessionStorage.setItem(k, String(now))
      return true
    }
    const last = Number(raw)
    if (Number.isFinite(last) && now - last > ttlMs) {
      sessionStorage.setItem(k, String(now))
      return true
    }
    return false
  } catch {
    return true
  }
}

export const bucketize = (value: number, buckets: number[]) => {
  if (value < 0) return 'negative'
  for (let i = 0; i < buckets.length - 1; i++) {
    if (value >= buckets[i] && value < buckets[i + 1]) {
      return `${buckets[i]}-${buckets[i + 1] - 1}`
    }
  }
  return `${buckets[buckets.length - 1]}+`
}

export const sanitizeQuery = (query: string) => {
  return query
    .trim()
    .toLowerCase()
    .replace(/[^\w\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .slice(0, 50)
}
